import GaliPlayerBadge from './GaliPlayerBadge';
import { firstDefined, playerName } from '../utils/galiDisplay';

const keyForTab = { batting: 'runs', bowling: 'wickets', fielding: 'dismissals', mvp: 'mvpScore' };
const GaliLeaderboardTable = ({ rows = [], tab = 'batting' }) => (
  <section className="gali-card">
    <div className="gali-table-wrap">
      <table className="table align-middle mb-0">
        <thead><tr><th>Rank</th><th>Name</th><th>Key stat</th><th>Label</th></tr></thead>
        <tbody>
          {rows.length ? rows.map((row, index) => (
            <tr key={row.id || row.playerId || row.tempPlayerId || index}>
              <td>{firstDefined(row.rank, index + 1)}</td>
              <td>{playerName(row)} {row.isTemp || row.tempPlayerId ? <GaliPlayerBadge type="temp" /> : null}</td>
              <td>{firstDefined(row[keyForTab[tab]], row.points, row.score, '-')}</td>
              <td>{row.isLinkedTempAggregate ? 'Linked aggregate' : firstDefined(row.label, row.teamName, '-')}</td>
            </tr>
          )) : <tr><td colSpan="4" className="text-muted">No backend leaderboard rows.</td></tr>}
        </tbody>
      </table>
    </div>
  </section>
);
export default GaliLeaderboardTable;
